module.exports = __webpack_public_path__ + "img/hushed_face.81393040.gif";